export const contentRatings = {
  ALL: 'all',
  MATURE: 'mature',
};

export default _.values(contentRatings);



// WEBPACK FOOTER //
// ./src/shared/constants/content-ratings.js